import config from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagementsDemo.config'
import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from 'app/shared-components/SkyBaseDataGrid'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const EngagementsDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={config}
            featuresLists={featuresLists}
        />
    )
}

export default EngagementsDemoPage
